import React from "react"
import { StaticImage } from "gatsby-plugin-image"

import AnimatedSection from "../animated-section"

const Download = ({ className }) => {
  return (
    <AnimatedSection
      className={className}
      leftElement={
        <div>
          <h2 className="dark text-sm-center">
            <em>Télécharge</em> l'application
          </h2>
          <p>
            Télécharge WeRECY sur l’App Store d’Apple ou Google pour commencer
            l’aventure. Tu pourras rapidement sélectionner tes objets dormants à
            recycler.
          </p>
        </div>
      }
      rightElement={
        <StaticImage
          height={400}
          placeholder="blurred"
          src="../../images/index_download-app.png"
          alt=""
        />
      }
    />
  )
}

export default Download
